/* Publish by EComposer at 2024-06-13 17:55:35*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cyxxtm2r85l"]=  window.__ectimmers["ecom-cyxxtm2r85l"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-cyxxtm2r85l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyxxtm2r85l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjj8nyz30k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjj8nyz30k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-39mcfsbmg4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-39mcfsbmg4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6tdnfwnbam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6tdnfwnbam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cewfcfgjo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cewfcfgjo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr0r7lac4a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr0r7lac4a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9hfc2262mv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9hfc2262mv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5agkqguo5eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5agkqguo5eh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ckbx1xkuj3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ckbx1xkuj3', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p6bbz5e2lc"]=  window.__ectimmers["ecom-p6bbz5e2lc"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-p6bbz5e2lc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6bbz5e2lc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91ow2oco99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91ow2oco99', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpe9sxmbfj9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpe9sxmbfj9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5bmoxay6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5bmoxay6b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qcj3rz31ns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qcj3rz31ns', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c10qkrlv5eq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c10qkrlv5eq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vi2184o8yme').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vi2184o8yme', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ti94mst46kr"]=  window.__ectimmers["ecom-ti94mst46kr"] || {};
const t=this.$el;if(!t)return;let r=this.settings.link_redirect,i=t.querySelector('.ecom-contact-form-file[type="file"]');const _=this.id;function g(){if(!r)return!1;let l=r.href;if(l=="")return!1;let m=r.target;window.location.href.includes("contact_posted=true")&&(m==="_blank"?window.open(l):window.location.href=l)}g();const o=t.querySelector("#ecom-contact-form-"+_);if(!o)return;const n=o.querySelector(".ecom__form-button");if(!n)return;i&&(o.setAttribute("enctype","multipart/form-data"),o.addEventListener("submit",function(l){if(!i.value||i.value==="")return;l.preventDefault(),l.stopImmediatePropagation(),n.classList.add("ecom-ajax-loading","ecom-loading");const m=o.querySelector('input[type="file"]');let e=new FormData,c=window.location.origin,u=window.EComposer&&window.EComposer.proxy_path;const w=`${c}${u}/contact-form`;e.append("file",m.files[0]),m.value&&u&&fetch(w,{method:"POST",body:e}).then(d=>d.json()).then(d=>{if(d.status==="success"){let q=m.name;m.remove();let x=document.createElement("input");x.value=d.src_file,x.type="hidden",x.name=q,o.appendChild(x),o.submit()}else alert(`Notice: ${d.message}`)}).catch(d=>console.error(d)).finally(function(){n.classList.remove("ecom-ajax-loading","ecom-loading")})}),i.addEventListener("change",function(){this.files[0].size>10485760&&(this.value="",alert("File size exceeds the maximum allowed limit (10MB)."))}));let f=t.querySelectorAll(".ecom-required--checkbox");n.addEventListener("click",function(l){f.length>0&&f.forEach(function(m){let e=m.querySelectorAll("input[type=checkbox]");if(e.length==0)return;let c=!1;e.forEach(function(u){u.checked&&(c=!0)}),c?e.forEach(function(u){u.required=!1}):e.forEach(function(u){u.required=!0})})}),o.dataset.ecTrackingId&&o.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:o.id,tracking_id:o.dataset.ecTrackingId})},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ti94mst46kr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ti94mst46kr', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}